import { useAccessTokenRoles } from '@b-stock/fe-core/bstock-next/components'

export const useIsServiceAccountOnly = (): boolean => {
  const accountRoles = useAccessTokenRoles()
  // we never expect service account to be a buyer
  // but because in this case buyer has more capabilities than service account (like making an offer or placing a bid)

  return (
    accountRoles?.service === 'ACTIVE' &&
    !accountRoles.buyer &&
    !accountRoles.seller
  )
}
